import styled from 'styled-components'
import breakpoints from '../../../config/settings/breakpoints'

export const Card = styled.article`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  padding: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.background};
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  }

  @media ${breakpoints.device.sm} {
    grid-template-columns: 220px 1fr auto;
    align-items: center;
    padding: 1.5rem;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.borderSubtle};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};

  @media ${breakpoints.device.sm} {
    height: 130px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
`

export const Role = styled.span`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const Year = styled.span`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.textMuted};

  &::before {
    content: '·';
    margin-inline-end: 0.5rem;
  }
`

export const Summary = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.textSecondary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const Highlights = styled.ul`
  margin: 0.25rem 0 0;
  padding-inline-start: 1.125rem;
  list-style: disc;

  li {
    font-size: 0.8125rem;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.textMuted};

    &:not(:last-child) {
      margin-bottom: 0.125rem;
    }
  }
`

export const TechStack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.25rem;
`

export const TechTag = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.textSecondary};
  background: ${({ theme }) => theme.colors.borderSubtle};
`

export const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media ${breakpoints.device.sm} {
    justify-content: flex-end;
    padding-inline-start: 1rem;
  }
`

export const ViewLink = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;

  &::after {
    content: ' →';
  }
`
